import React, { useCallback } from 'react';
import { useField } from 'formik';
import { TextInputTW, TextInputTWProps } from './TextInputTW';
import { useErrorText } from '../hooks/useErrorText';

export interface TextFieldTWProps extends TextInputTWProps {
  name: string;
}

export const TextFieldTW: React.FC<TextFieldTWProps> = ({ name, ...rest }) => {
  const [fieldInputProps, fieldMetaProps, fieldHelperProps] = useField<string>(name);
  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      fieldHelperProps.setTouched(true);
      fieldHelperProps.setValue(value);
      if (rest.onChange) {
        rest.onChange(value as any);
        fieldInputProps.onChange(e);
      }
    },
    [fieldHelperProps, fieldInputProps, rest]
  );

  const errorText = useErrorText<string>(fieldMetaProps);

  return <TextInputTW errorText={errorText} {...rest} {...fieldInputProps} onChange={onChange} />;
};
